export const pluralize = (total: number, str: string) => {
	if (total > 1) {
		return str + 's';
	} else {
		return str;
	}
};
